export var TitleVariants;
(function (TitleVariants) {
    TitleVariants["default"] = "default";
    TitleVariants["highlight"] = "highlight";
})(TitleVariants || (TitleVariants = {}));
export var TitleSizes;
(function (TitleSizes) {
    TitleSizes["base"] = "base";
    TitleSizes["variant"] = "variant";
    TitleSizes["overline"] = "overline";
})(TitleSizes || (TitleSizes = {}));
//# sourceMappingURL=constants.js.map